export function currencyFormat(
  amount: number,
  locales = 'en-US',
  minFraction = 2
) {
  return `$${(amount || 0).toLocaleString(locales, {
    minimumFractionDigits: minFraction,
    maximumFractionDigits: 2
  })}`;
}
